import { render, staticRenderFns } from "./TipoAgendaAtividadeList.vue?vue&type=template&id=77511580&scoped=true"
import script from "./TipoAgendaAtividadeList.vue?vue&type=script&lang=js"
export * from "./TipoAgendaAtividadeList.vue?vue&type=script&lang=js"
import style0 from "./TipoAgendaAtividadeList.vue?vue&type=style&index=0&id=77511580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77511580",
  null
  
)

export default component.exports